import { l as lodash } from './lodash-5c867657.js';

const getSortOptions = () => {
    return {
        'relevance': { sortField: 'relevancy', sortOrder: 'asc' },
        'newest-published': { sortField: 'document.sourceCreateTimestamp', sortOrder: 'desc' },
        'oldest-published': { sortField: 'document.sourceCreateTimestamp', sortOrder: 'asc' },
        'newest-modified': { sortField: 'document.sourceLastModifiedTimestamp', sortOrder: 'desc' },
        'oldest-modified': { sortField: 'document.sourceLastModifiedTimestamp', sortOrder: 'asc' },
    };
};
const getSortFieldMap = () => {
    return lodash.reduce(getSortOptions(), (r, v, k) => {
        r[k] = v.sortField;
        return r;
    }, {});
};
const getSortOrderMap = () => {
    return lodash.reduce(getSortOptions(), (r, v, k) => {
        r[k] = v.sortOrder;
        return r;
    }, {});
};

export { getSortFieldMap as a, getSortOrderMap as b, getSortOptions as g };
